<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="data-list-list-view" class="data-list-container">

        <vs-button radius icon="icon-plus" icon-pack="feather" @click="addOpenPopup()" class="ml-auto" style="margin-top: -43px;margin-bottom: 15px;"></vs-button>

        <div class="vx-row m-0">
            <div class="vx-col sm:w-1/12 w-full" style="font-weight: 600;font-size: .85rem;">{{ $t('id') }}</div>
            <div class="vx-col sm:w-5/12 w-full" style="font-weight: 600;font-size: .85rem;">{{ $t('title') }}</div>
            <div class="vx-col sm:w-3/12 w-full" style="font-weight: 600;font-size: .85rem;">{{ $t('status') }}</div>
            <div class="vx-col sm:w-3/12 w-full" style="font-weight: 600;font-size: .85rem;">{{ $t('action') }}</div>
        </div>

        <div v-for="(item) in items" id="category_tree">
            <vx-card class="mt-5">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/12 w-full">
                        <span v-if="item.child" class="float-left" style="margin-top: -9px;position:relative;width:35px;height: 24px;">
                            <span class="absolute plus_minus" style="top:5px; display: block" :id="'plus_'+item.id">
                                <feather-icon icon="PlusCircleIcon" svgClasses="cursor-pointer text-primary"  @click="showContent('plus', item.id)"></feather-icon>
                            </span>
                            <span class="absolute plus_minus" style="top:5px; display: none" :id="'minus_'+item.id">
                                <feather-icon icon="MinusCircleIcon" svgClasses="cursor-pointer text-primary"  @click="showContent('minus', item.id)"></feather-icon>
                            </span>
                        </span>
                        {{ item.id }}
                    </div>
                    <div class="vx-col sm:w-5/12 w-full">{{ item.title }}</div>
                    <div class="vx-col sm:w-3/12 w-full">{{ item.show ? 'Active' : 'Deactive' }}</div>
                    <div class="vx-col sm:w-3/12 w-full">
                        <a @click="getById(item.id)" style="cursor:pointer;">{{ $t('edit') }}</a>
                        <span> | </span>
                        <a @click="remove(item.id)" style="cursor:pointer;">{{ $t('delete') }}</a>
                    </div>
                </div>
            </vx-card>

            <div v-if="item.child" v-for="(item2) in item.child" class="ml-5 child" :class="'child_'+item.id">
                <vx-card class="mt-5">
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/12 w-full">
                            <span v-if="item2.child" class="float-left" style="margin-top: -9px;position:relative;width:35px;height: 24px;">
                                <span class="absolute plus_minus" style="top:5px; display: block" :id="'plus_'+item2.id">
                                    <feather-icon icon="PlusCircleIcon" svgClasses="cursor-pointer text-primary"  @click="showContent('plus', item2.id)"></feather-icon>
                                </span>
                                <span class="absolute plus_minus" style="top:5px; display: none" :id="'minus_'+item2.id">
                                    <feather-icon icon="MinusCircleIcon" svgClasses="cursor-pointer text-primary"  @click="showContent('minus', item2.id)"></feather-icon>
                                </span>
                            </span>
                            {{ item2.id }}
                        </div>
                        <div class="vx-col sm:w-5/12 w-full">{{ item2.title }}</div>
                        <div class="vx-col sm:w-3/12 w-full">{{ item2.show ? 'Active' : 'Deactive' }}</div>
                        <div class="vx-col sm:w-3/12 w-full">
                            <a @click="getById(item2.id)" style="cursor:pointer;">{{ $t('edit') }}</a>
                            <span> | </span>
                            <a @click="remove(item2.id)" style="cursor:pointer;">{{ $t('delete') }}</a>
                        </div>
                    </div>
                </vx-card>

                <vx-card v-if="item2.child" v-for="(item3) in item2.child" class="ml-5 mt-5 child" :class="'child_'+item2.id">
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/12 w-full">{{ item3.id }}</div>
                        <div class="vx-col sm:w-5/12 w-full">{{ item3.title }}</div>
                        <div class="vx-col sm:w-3/12 w-full">{{ item3.show ? 'Active' : 'Deactive' }}</div>
                        <div class="vx-col sm:w-3/12 w-full">
                            <a @click="getById(item3.id)" style="cursor:pointer;">{{ $t('edit') }}</a>
                            <span> | </span>
                            <a @click="remove(item3.id)" style="cursor:pointer;">{{ $t('delete') }}</a>
                        </div>
                    </div>
                </vx-card>
            </div>
        </div>
        <div></div> <!-- NOT REMOVE!!!!!! -->

        <vs-popup class="holamundo" v-bind:title="'Category '+modalButtonText" :active.sync="addAndEditPopup">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('title') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" name="title" v-model="editOrAdd.title" />
                </div>
            </div>
            <div class="vx-row mb-6" v-if="editOrAdd.id === 0">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('parent') }} *</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <div class="con-select w-full select-large">
                        <div class="input-select-con">
                            <select v-model="editOrAdd.parent_id" class="input-select vs-select--input" style="padding: 8.8px;">
                                <option :key="index" :value="item.value" v-for="(item,index) in categories">{{ item.text }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span>{{ $t('active') }}</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-switch color="success" name="status" v-model="editOrAdd.show" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full"></div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-button color="success" type="filled" @click="editOrAddUser()">{{ modalButtonText }}</vs-button>
                </div>
            </div>
        </vs-popup>

    </div>
</template>

<script>

    export default {
        components: {},
        data() {
            return {
                categories: [],
                locale: this.$i18n.locale,
                userInfo: window.userInfo,
                modalButtonText: this.$t('save'),
                items: [],
                addAndEditPopup: false,
                addAndEditPopupAuto: false,
                editAndAddTemplate: {
                    id: 0,
                    title: '',
                    parent_id: 0,
                    show: true,
                    _method: 'POST'
                },
                editOrAdd: {},

                show: false,
                selected: [],
                itemsPerPage: 10,
                isMounted: false,
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            }
        },
        methods: {
            openConfirm(id) {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: this.$t('confirm'),
                    text: this.$t('doYouWantToDelete'),
                    accept: ()=>{ this.remove(id, false) }
                })
            },
            loadCategory(){
                const thisIns = this;
                axios.get(apiUrl + '/categories/getList?token=' + token)
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.categories = data.data;
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            getById(id){
                this.modalButtonText = this.$t('save');
                this.loadCategory();
                this.$vs.loading();
                this.editOrAdd = JSON.parse(JSON.stringify(this.editAndAddTemplate));
                this.editOrAdd.id = id;
                const thisIns = this;

                // eslint-disable-next-line no-undef
                axios.get(apiUrl+'/categories/'+id+'/edit?token='+token)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            for(var index in data.data) {
                                if (data.data.hasOwnProperty(index)) {
                                    thisIns.editOrAdd[index] = data.data[index];
                                }
                            }
                            thisIns.addAndEditPopup = true;
                            thisIns.addAndEditPopupAuto = false;
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            editOrAddUser(){
                this.$vs.loading();
                let url = apiUrl+'/categories?token='+token;
                this.editOrAdd._method = 'POST';
                if(this.editOrAdd.id !== 0){
                    url = apiUrl+'/categories/'+this.editOrAdd.id+'?token='+token;
                    this.editOrAdd._method = 'PUT';
                }

                const thisIns = this;
                let sendData = new FormData();

                for(let index in thisIns.editOrAdd) {
                    let value = thisIns.editOrAdd[index];
                    if (index === 'show'){
                        if (value == true || value == '1') value = 1;
                        else value = 0;
                    }
                    sendData.append(index, value);
                }

                axios.post(url, sendData)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            thisIns.items = data.data;
                            thisIns.addAndEditPopup = false;
                            thisIns.addAndEditPopupAuto = true;
                            thisIns.loadCategory();
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            },
            addOpenPopup(){
                this.editOrAdd = JSON.parse(JSON.stringify(this.editAndAddTemplate));
                this.modalButtonText = this.$t('add');
                this.addAndEditPopup = true;
                this.addAndEditPopupAuto = false;
            },
            remove(id, needConfirm = true){
                if (needConfirm) {
                    this.openConfirm(id);
                    return false;
                }
                const thisIns = this;
                // eslint-disable-next-line no-undef
                axios.post(apiUrl+'/categories/'+id+'?token='+token, {'_method' : 'DELETE'})
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            thisIns.items = data.data;
                            thisIns.loadCategory();
                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }

                    });
            },
            showContent(act, id){
                let plus = document.getElementById('plus_'+id);
                let minus = document.getElementById('minus_'+id);
                let child = document.getElementsByClassName('child_'+id);
                if (act === 'plus'){
                    minus.style.display = 'block';
                    plus.style.display = 'none';

                    for (let i = 0; i < child.length; i++) {
                        child[i].classList.add('active');
                    }
                }else{
                    plus.style.display = 'block';
                    minus.style.display = 'none';

                    for (let i = 0; i < child.length; i++) {
                        child[i].classList.remove('active');
                    }
                }
            },
        },
        created() {
            const thisIns = this;
            // eslint-disable-next-line no-undef
            axios.get(apiUrl+'/categories?token='+token)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.items = data.data;
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });

            axios.get(apiUrl + '/categories/getList?token=' + token)
                .then(function (response) {

                    let data = response.data;
                    if (data.code === 200) {
                        thisIns.categories = data.data;
                    } else {
                        if (data.code === 401) {
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                });
        },
        mounted() {
            this.isMounted = true;
        },
        watch: {
            addAndEditPopup(state){
                if(!state && !this.addAndEditPopupAuto) {
                    this.addAndEditPopup = true;
                    if(confirm('Close Popup?')) {
                        this.addAndEditPopup = false;
                    }
                }
            }
        }
    }
</script>

<style lang="scss">

    #category_tree{
        .child{
            display: none;
            &.active{
                display: block;
            }
        }
    }

    /*.active {
        path {
            fill: #d92121 !important;
        }
    }*/



    .ui-selected {
        background: rgba(var(--vs-primary), .05) !important;
        color: rgba(var(--vs-primary), 1);
        -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
        box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
    }

    .td-check {
        display: none !important;
    }

    #data-list-list-view {
        .vs-con-table {

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                    td {
                        padding: 20px;

                        &:first-child {
                            border-top-left-radius: .5rem;
                            border-bottom-left-radius: .5rem;
                        }

                        &:last-child {
                            border-top-right-radius: .5rem;
                            border-bottom-right-radius: .5rem;
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
